import { useState } from 'react';
import { Modal } from '../components/Modal';

export function SettingsPage({ business, onUpdate }) {
  const [showEdit, setShowEdit] = useState(false);
  const [form, setForm]         = useState(business || {});
  const [saving, setSaving]     = useState(false);

  const save = async () => {
    setSaving(true);
    try { await onUpdate(form); setShowEdit(false); }
    catch (e) { alert(e.message); }
    setSaving(false);
  };

  return (
    <div className="content">
      <div className="content-inner">
        <div className="section-title" style={{ marginBottom: 10 }}>Business Profile</div>
        <div className="settings-card">
          <div className="settings-row" style={{ cursor: 'pointer' }} onClick={() => { setForm(business); setShowEdit(true); }}>
            <span className="settings-icon">🏪</span>
            <div>
              <div className="settings-label">{business?.name || 'My Business'}</div>
              <div className="settings-sub">Business Name</div>
            </div>
            <span className="settings-arrow">›</span>
          </div>
          <div className="settings-row">
            <span className="settings-icon">👤</span>
            <div>
              <div className="settings-label">{business?.owner || 'Owner Name'}</div>
              <div className="settings-sub">Owner</div>
            </div>
          </div>
          <div className="settings-row">
            <span className="settings-icon">📞</span>
            <div>
              <div className="settings-label">{business?.phone || 'Not set'}</div>
              <div className="settings-sub">Phone Number</div>
            </div>
          </div>
          <div className="settings-row">
            <span className="settings-icon">📍</span>
            <div>
              <div className="settings-label">{business?.address || 'Not set'}</div>
              <div className="settings-sub">Address</div>
            </div>
          </div>
          <div className="settings-row" style={{ cursor: 'pointer' }} onClick={() => { setForm(business); setShowEdit(true); }}>
            <span className="settings-icon">✏️</span>
            <div>
              <div className="settings-label">Edit Business Details</div>
              <div className="settings-sub">Update your business info</div>
            </div>
            <span className="settings-arrow">›</span>
          </div>
        </div>

        <div className="section-title" style={{ marginBottom: 10 }}>App Settings</div>
        <div className="settings-card">
          {[
            { icon: '🌐', label: 'Language', sub: 'English (India)' },
            { icon: '💱', label: 'Currency', sub: '₹ Indian Rupee' },
            { icon: '🔔', label: 'Reminders', sub: 'WhatsApp & SMS' },
            { icon: '🔒', label: 'App Lock', sub: 'Disabled' },
            { icon: '☁️', label: 'Cloud Backup', sub: 'Auto backup enabled' },
          ].map((item, i) => (
            <div key={i} className="settings-row" style={{ cursor: 'pointer' }}>
              <span className="settings-icon">{item.icon}</span>
              <div>
                <div className="settings-label">{item.label}</div>
                <div className="settings-sub">{item.sub}</div>
              </div>
              <span className="settings-arrow">›</span>
            </div>
          ))}
        </div>

        <div className="section-title" style={{ marginBottom: 10 }}>Data & Export</div>
        <div className="settings-card">
          {[
            { icon: '📤', label: 'Export to Excel', sub: 'Download as .xlsx file' },
            { icon: '📄', label: 'Export to PDF', sub: 'Download statement PDF' },
            { icon: '🔄', label: 'Backup Data', sub: 'Save to Google Drive' },
            { icon: '📥', label: 'Restore Backup', sub: 'Restore from backup' },
          ].map((item, i) => (
            <div key={i} className="settings-row" style={{ cursor: 'pointer' }}>
              <span className="settings-icon">{item.icon}</span>
              <div>
                <div className="settings-label">{item.label}</div>
                <div className="settings-sub">{item.sub}</div>
              </div>
              <span className="settings-arrow">›</span>
            </div>
          ))}
        </div>

        <div className="section-title" style={{ marginBottom: 10 }}>About</div>
        <div className="settings-card">
          <div className="settings-row">
            <span className="settings-icon">📒</span>
            <div>
              <div className="settings-label">Cashbook – Bahi Khata</div>
              <div className="settings-sub">Version 1.0.0</div>
            </div>
          </div>
          <div className="settings-row">
            <span className="settings-icon">⭐</span>
            <div>
              <div className="settings-label">Rate this App</div>
              <div className="settings-sub">Tell us what you think</div>
            </div>
            <span className="settings-arrow">›</span>
          </div>
        </div>
      </div>

      {showEdit && (
        <Modal title="✏️ Edit Business" onClose={() => setShowEdit(false)}>
          {[
            { key: 'name',    label: 'Business Name', placeholder: 'e.g. Sharma General Store' },
            { key: 'owner',   label: 'Owner Name',    placeholder: 'e.g. Ramesh Sharma' },
            { key: 'phone',   label: 'Phone Number',  placeholder: '10-digit mobile' },
            { key: 'address', label: 'Address',       placeholder: 'Shop / Office address' },
          ].map(f => (
            <div className="form-group" key={f.key}>
              <label className="form-label">{f.label}</label>
              <input className="form-input" placeholder={f.placeholder}
                value={form[f.key] || ''}
                onChange={e => setForm(prev => ({ ...prev, [f.key]: e.target.value }))} />
            </div>
          ))}
          <button className="btn btn-blue" style={{ width: '100%', justifyContent: 'center', padding: 11 }}
            onClick={save} disabled={saving}>
            {saving ? 'Saving…' : 'Save Changes'}
          </button>
        </Modal>
      )}
    </div>
  );
}
